module.exports = __webpack_public_path__ + "static/media/align_right_w.66291422.svg";